/**
 * RESPONSIBILITY: the frame every /adc block shares — its band, its column and its heading.
 *
 * Alternate bands take the tint from the stylesheet (`:nth-of-type`), not from a flag on
 * each block: reordering blocks must not leave two tinted ones side by side. The heading
 * is here because every template may carry one and an empty one draws nothing.
 */
import type { ReactNode } from 'react';
import { slugify } from '../commons/slug';

export function AdcBand({ theme, heading, children }: { theme: string; heading?: string; children?: ReactNode }) {
  return (
    <section className={`adc-band adc-band-${slugify(theme)}`}>
      <div className="adc-stack">
        {heading ? <h2>{heading}</h2> : null}
        {children}
      </div>
    </section>
  );
}
